import React from "react"

const DragonSkull = ({
  colors = [
    "#262261",
    "#B5B5AE",
    "#SVGID_",
    "#33322F",
    "#BF0A00",
    "#E59572",
    "#FFF4BF",
    "#FFF7D2",
    "#FFFBE6",
    "#FFFDF4",
    "#FFFFFD",
    "#FFFFFF",
    "#E7A4A0"
  ]
}) => {
  return (
    <g id="DragonSkull">
      <ellipse
        opacity="0.3"
        fill={colors[0]}
        cx="68.571"
        cy="15.703"
        rx="6.615"
        ry="3.129"
      />
      <path
        opacity="0.3"
        fill="#21376C"
        d="M76.4373016,15.8818722 l-15.1968765-0.0893936l0.983326,2.2348328c0,0.5363617-0.0893936,1.2515068,0.0893898,1.6984749 c0.0893936-0.715147,0.7151451-1.430294,1.1621132-1.6984749h0.2681808 c-0.0893936,0.3575745-0.0893936,1.0727215,0.1787834,1.5196896c0-0.2681808,0.2681808-0.715147,0.4469681-0.9833279 c0.0893936,0.0893936,0.1787796,0.1787872,0.2681808,0.1787872c0,0.3575726,0.0893936,0.715147,0.2681808,0.9833279 l0.2681885-0.6257553c0.089386,0.0893936,0.1787796,0.1787872,0.2681808,0.1787872c0,0.715147,0,1.6090813,0.2681808,2.1454411 c0.0893936-0.7151451,0.5363617-1.2515068,0.8045425-1.430294h0.0893936c0,0,0.0893936,0.0893936,0.0893936,0.1787872 c0,0.5363617,0.089386,1.6090813,0.4469604,1.8772621c0-0.3575745,0.1787872-0.8045406,0.3575821-1.0727215h2.5030136 c0.1787872,0.2681789,0.3575745,0.7151451,0.3575745,1.0727215c0.3575745-0.2681808,0.4469681-1.3409004,0.4469681-1.7878685 c0.0893936-0.0893936,0.1787872-0.1787872,0.1787872-0.1787872l0,0c0.2681808,0.2681789,0.7151489,0.715147,0.8045349,1.430294 c0.2681885-0.6257534,0.2681885-1.5196877,0.2681885-2.1454411c0.089386-0.0893936,0.1787796-0.1787872,0.3575745-0.2681789 l0.2681808,0.5363617c0.1787872-0.2681808,0.2681808-0.6257553,0.2681808-0.8939342 c0.0893936-0.0893936,0.2681885-0.1787872,0.3575745-0.2681789c0.1787872,0.2681789,0.4469681,0.7151451,0.4469681,0.983326 c0.2681808-0.4469662,0.2681808-0.983326,0.2681808-1.430294c0.0893936,0,0.0893936-0.0893936,0.1787872-0.0893936h0.0893936 c0.3575745,0.3575726,1.0727158,1.0727215,1.162117,1.6984749c0.1787796-0.5363617,0.1787796-1.2515068,0.0893936-1.6984749 L76.4373016,15.8818722z"
      />
      <path
        fill={colors[1]}
        d="M77.0630569,16.0606594l-1.8772659-1.2515078 c0,0,1.9666519-3.4863415,1.2515106-3.4863415c-1.6090851,0.1787863-2.0560532-0.8939333-2.5924149-1.6984739 c-0.1787796-0.1787872-0.1787796-0.3575735-0.2681732-0.4469671c-0.4469681-0.8939342-0.2681808-2.6818018-0.2681808-2.6818018 l-1.3409042,1.0727205c-1.0727158-0.8939338-2.2348328-0.0893936-2.6818008-0.1787868l-0.8045425-2.6818013l-0.8939362,2.6818013 c-0.4469604,0.0893931-1.6090775-0.8045406-2.5924072,0.1787868l-1.1621094-1.0727205 c0,0,0.2681808,1.6984739-0.1787872,2.5030146c-0.1787872,0.2681808-0.3575745,0.5363607-0.3575745,0.715147 c-0.2681808,0.9833279-0.6257553,1.9666548-2.5030136,1.9666548c-0.4469681,0.0893936,1.2515068,3.128768,1.2515068,3.128768 l-1.8772583,1.3409014h1.8772583c0,0.3575726-0.0893898,0.8045387,0.0893936,1.1621132 c0.0893936-0.4469662,0.7151451-0.8939342,1.1621132-1.1621132h0.2681808 c-0.0893936,0.2681789-0.0893936,0.6257534,0.1787872,0.9833279c0-0.1787872,0.2681808-0.4469681,0.4469604-0.6257553 c0.0893936,0,0.1787872,0.0893955,0.2681885,0.1787872c0,0.1787872,0.089386,0.4469681,0.2681808,0.6257534l0.2681808-0.3575726 c0.0893936,0.0893936,0.1787872,0.0893936,0.2681808,0.1787872c0,0.4469662,0,0.983326,0.2681885,1.430294 c0.089386-0.4469681,0.5363541-0.8045406,0.8045349-0.8939342h0.0893936c0,0,0.0893936,0,0.0893936,0.0893936 c0,0.3575726,0.0893936,0.9833279,0.4469681,1.2515068c0-0.2681789,0.1787796-0.5363598,0.3575745-0.715147h2.5030136 c0.1787872,0.1787891,0.3575821,0.4469681,0.3575821,0.715147c0.3575745-0.1787872,0.4469604-0.8045406,0.4469604-1.1621132 c0.0893936-0.0893936,0.1787872-0.0893936,0.1787872-0.0893936l0,0c0.2681808,0.1787872,0.7151489,0.4469662,0.8045425,0.8939342 c0.2681808-0.3575745,0.2681808-0.9833279,0.2681808-1.3409004c0.0893936-0.0893936,0.1787872-0.0893936,0.3575745-0.1787872 l0.2681808,0.3575745c0.1787872-0.1787872,0.2681885-0.3575745,0.2681885-0.5363617 c0.089386-0.0893936,0.2681808-0.0893936,0.3575745-0.1787853c0.1787796,0.1787853,0.4469681,0.4469662,0.4469681,0.6257534 c0.2681808-0.2681808,0.2681808-0.6257534,0.2681808-0.8939342c0.0893936,0,0.0893936-0.0893936,0.1787796-0.0893936h0.0893936 c0.3575745,0.2681808,1.0727158,0.715147,1.162117,1.1621132c0.1787872-0.3575726,0.1787872-0.8045406,0.0893936-1.1621151 h1.9666519L77.0630569,16.0606594L77.0630569,16.0606594z"
      />
      <path
        fill="url(#SVGID_12_)"
        d="M75.0963974,13.3788576c0-0.0893936-0.2681808,0.3575726-0.4469681,0.8939333 c-0.0893936-0.3575726-0.3575745-0.5363598-0.3575745-0.3575726c0,0.0893936,0,0.715147,0,0.8045397 c0,0.1787863-0.1787796-0.8045397-0.1787796-0.5363607c-0.0893936,0-0.2681885,0.1787863-0.3575821,0.2681808 c-0.089386,0.0893936,0,0.715147-0.089386,0.715147c-0.0893936,0-0.0893936-0.4469671-0.1787872-0.5363607 c-0.1787796,0-0.4469681,0.0893936-0.4469681,0.0893936c-0.0893936,0-0.0893936,0.4469671-0.0893936,1.1621141 c-0.089386,0-0.1787796-0.8045397-0.3575745-0.9833279c-0.1787796,0-0.2681808,0-0.4469604-0.0893936 c-0.1787872,0-0.3575745-0.0893936-0.3575745,0c0,0,0.1787796,0.9833279,0.089386,0.9833279 c-0.089386,0-0.1787796-0.8045406-0.4469681-0.9833279c-0.2681808,0.0893936-0.7151489,0-0.7151489,0l-0.1787796,1.1621141 L70.358551,14.719758c0,0-0.1787796-0.0893936-0.4469681-0.1787863c-0.1787796-0.0893936-0.2681808,1.3409004-0.3575745,1.2515068 c-0.2681808-0.0893936-0.7151489-1.3409004-0.8045425-1.6090813c0-0.0893936,0-0.1787863,0-0.1787863 s-0.5363541,1.6984739-0.8939285,1.6984739c-0.0893936,0-0.1787872-1.3409014-0.3575745-1.2515068 c-0.2681885,0.0893936-0.4469681,0.1787863-0.4469681,0.1787863l-0.1787872,1.2515068l-0.1787796-1.1621141 c0,0-0.4469681,0-0.7151489,0c-0.1787872,0.1787863-0.2681885,0.9833279-0.4469681,0.9833279 c-0.0893936,0,0.089386-0.9833279,0.089386-0.9833279s-0.1787796,0-0.3575745,0c-0.1787796,0-0.2681808,0-0.4469604,0.0893936 c0.089386,0.1787872,0,0.8939342-0.0893936,0.8939342c0-0.715147-0.0893936-1.1621141-0.0893936-1.1621141 c-0.0893936,0-0.2681808-0.0893936-0.4469681-0.0893936c-0.0893936,0.0893936-0.0893936,0.5363607-0.1787796,0.5363607 c-0.0893936,0,0-0.6257544-0.0893936-0.715148c-0.0893936,0-0.2681808-0.1787863-0.3575783-0.2681799 c0-0.2681808-0.1787872,0.715147-0.1787872,0.5363607c0-0.0893936,0-0.715147,0-0.8045406 c-0.0893898-0.1787863-0.268177,0-0.3575745,0.3575735c-0.1787872-0.5363607-0.4469643-0.8939333-0.4469643-0.8939333 c0,0.0893936,0.1787872,1.430294,0.1787872,1.430294l-0.6257591,1.0727215v0.0893936c0,0,0.5363579-0.5363607,0.8045425-0.6257534 c0.268177-0.0893936,0.3575745,0.6257534,0.3575745,0.6257534l0.2681808,0.0893936c0,0,0.1787872-0.2681808,0.3575706-0.3575735 c0.1787796,0,0.0893936,0.5363617,0.0893936,0.5363617l0.2681808,0.1787853c0,0,0.0893936-0.5363598,0.3575745-0.2681799 c0.2681808,0.1787863,0.1787872,0.5363607,0.1787872,0.5363607s0.2681808,0.1787872,0.3575745,0.0893936 c0-0.0893936,0.5363541-0.6257534,0.7151489-0.5363598c0.1787796,0.0893936,0.2681808,1.0727196,0.2681808,1.0727196 l0.1787872,0.1787872c0,0,0.3575745-0.8045406,0.5363541-0.715147c0.1787872,0.0893936,0.2681808,0.8045387,0.2681808,0.8045387 l0.3575821-0.1787853c0,0,0.1787796,0.0893936,0.1787796,0.1787853c0,0.0893936,0.3575745,0.0893936,0.5363617,0 c0.0893936,0,0.0893936-0.6257534,0.0893936-1.2515068c0,0.715147,0,1.2515068,0.089386,1.3409004 c0.1787872,0.0893936,0.5363617,0,0.5363617,0l0.1787872-0.1787872l0.3575745,0.1787872 c0,0,0.089386-0.8045406,0.2681808-0.8045406c0.1787796-0.0893936,0.5363617,0.715147,0.5363617,0.715147l0.1787796-0.1787853 c0,0,0.0893936-0.9833279,0.2681808-1.0727215s0.7151489,0.5363617,0.7151489,0.5363617 c0,0.0893936,0.3575821-0.0893936,0.3575821-0.0893936s0-0.3575745,0.1787796-0.5363617 c0.2681808-0.1787863,0.3575745,0.2681808,0.3575745,0.2681808l0.2681808-0.1787872c0,0-0.089386-0.6257534,0.0893936-0.5363607 c0.1787872,0,0.3575745,0.3575735,0.3575745,0.3575735l0.2681885-0.0893936c0,0,0.089386-0.715147,0.3575745-0.6257534 c0.2681808,0.0893936,0.8045349,0.6257534,0.8045349,0.6257534v-0.0893936l-0.5363617-0.9833269 C74.9176102,14.719758,75.0963974,13.4682512,75.0963974,13.3788576z"
      />
      <path
        fill={colors[3]}
        d="M65.620697,12.7531042c0.3575821-0.2681808,1.9666519-3.2181616,1.6090851-3.5757351 c-0.4469681-0.3575745-0.8939285-0.8045406-1.5196838-0.8045406c-0.6257477,0-2.145443,2.5030136-2.3242264,3.128768 c-0.0893898,0.1787863,0.0893936,1.430294,0.5363617,1.6090803C64.1904068,13.289465,65.2631226,13.0212841,65.620697,12.7531042 z"
      />
      <path
        opacity="0.41"
        d="M63.7434425,11.85917 c0.1787834-0.6257534,1.6984749-3.128768,2.3242226-3.128768c0.5363617,0,0.8939362,0.2681799,1.2515106,0.5363598 c0-0.0893927,0-0.0893927-0.0893936-0.1787863c-0.4469681-0.3575735-0.8939285-0.8045406-1.5196838-0.8045406 c-0.6257477,0-2.145443,2.5030146-2.3242264,3.128768c-0.0893898,0.1787872,0.0893936,1.430295,0.5363617,1.6090813h0.0893936 C63.7434425,12.6637106,63.6540451,11.9485636,63.7434425,11.85917z"
      />
      <path
        fill={colors[3]}
        d="M67.3191757,13.9152184l-1.4302902,0.2681799l1.6090851-1.9666538 C67.6767502,12.1273508,68.2131119,13.289465,67.3191757,13.9152184z"
      />
      <polygon
        opacity="0.41"
        points="66.5146332,14.0940046 67.7661438,12.3955307 67.6767502,12.1273508 66.0676651,14.1833982"
      />
      <path
        fill={colors[3]}
        d="M71.610054,12.6637106c-0.3575745-0.2681799-1.9666519-3.2181616-1.6090851-3.5757351 c0.4469681-0.3575735,0.8939362-0.8045406,1.5196838-0.8045406c0.6257553,0,2.1454468,2.5030146,2.3242264,3.1287689 c0.0893936,0.1787872-0.089386,1.430295-0.5363541,1.6090813C72.9509583,13.2000704,71.9676285,12.9318905,71.610054,12.6637106z"
      />
      <path
        opacity="0.41"
        d="M73.5767136,11.7697773 c-0.0893936-0.5363607-1.6984787-3.1287689-2.3242264-3.1287689c-0.5363617,0-0.8939362,0.2681808-1.2515106,0.5363607 c0-0.0893936,0-0.0893936,0.0893936-0.1787872c0.4469681-0.3575735,0.8939362-0.8045406,1.5196838-0.8045406 s2.1454391,2.5030146,2.3242264,3.1287689c0.0893936,0.1787863-0.0893936,1.430295-0.5363617,1.6090813h-0.089386 C73.5767136,12.574317,73.5767136,11.9485636,73.5767136,11.7697773z"
      />
      <g>
        <path
          fill={colors[3]}
          d="M69.9115829,13.8258238l1.4302979,0.2681808l-1.6090851-1.9666538 C69.6434021,12.0379562,69.0176544,13.2000704,69.9115829,13.8258238z"
        />
        <polygon
          opacity="0.41"
          points="70.8055191,14.004612 69.4646149,12.3061371 69.6434021,12.0379562 71.1630859,14.0940046"
        />
      </g>
      <g>
        <linearGradient
          id="SVGID_13_"
          gradientUnits="userSpaceOnUse"
          x1="68.705"
          y1="2579.978"
          x2="68.947"
          y2="2559.76"
          gradientTransform="translate(0 -2560)"
        >
          <stop offset="0" stopColor="#bf0a00" />
          <stop offset="0" stopColor="#e59572" stopOpacity="0.936" />
          <stop offset="0" stopColor="#fff4bf" stopOpacity="0.89" />
          <stop offset="0.079" stopColor="#fff7d2" stopOpacity="0.795" />
          <stop offset="0.191" stopColor="#fffbe6" stopOpacity="0.661" />
          <stop offset="0.319" stopColor="#fffdf4" stopOpacity="0.507" />
          <stop offset="0.476" stopColor="#fffffd" stopOpacity="0.319" />
          <stop offset="0.742" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="SVGID_14_"
          gradientUnits="userSpaceOnUse"
          x1="68.779"
          y1="2559.912"
          x2="68.752"
          y2="2574.816"
          gradientTransform="translate(0 -2560)"
        >
          <stop offset="0.059" stopColor="#bf0a00" />
          <stop offset="0.522" stopColor="#e7a4a0" stopOpacity="0.383" />
          <stop offset="0.81" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <path
          fill="url(#SVGID_13_)"
          d="M77.0630569,16.0606594l-1.8772659-1.2515078c0,0,1.9666519-3.4863415,1.2515106-3.4863415 c-1.6090851,0.1787863-2.0560532-0.8939333-2.5924149-1.6984739c-0.1787796-0.1787872-0.1787796-0.3575735-0.2681732-0.4469671 c-0.4469681-0.8939342-0.2681808-2.6818018-0.2681808-2.6818018l-1.3409042,1.0727205 c-1.0727158-0.8939338-2.2348328-0.0893936-2.6818008-0.1787868l-0.8045425-2.6818013l-0.8939362,2.6818013 c-0.4469604,0.0893931-1.6090775-0.8045406-2.5924072,0.1787868l-1.1621094-1.0727205 c0,0,0.2681808,1.6984739-0.1787872,2.5030146c-0.1787872,0.2681808-0.3575745,0.5363607-0.3575745,0.715147 c-0.2681808,0.9833279-0.6257553,1.9666548-2.5030136,1.9666548c-0.4469681,0.0893936,1.2515068,3.128768,1.2515068,3.128768 l-1.8772583,1.3409014h1.8772583c0,0.3575726-0.0893898,0.8045387,0.0893936,1.1621132 c0.0893936-0.4469662,0.7151451-0.8939342,1.1621132-1.1621132h0.2681808 c-0.0893936,0.2681789-0.0893936,0.6257534,0.1787872,0.9833279c0-0.1787872,0.2681808-0.4469681,0.4469604-0.6257553 c0.0893936,0,0.1787872,0.0893955,0.2681885,0.1787872c0,0.1787872,0.089386,0.4469681,0.2681808,0.6257534l0.2681808-0.3575726 c0.0893936,0.0893936,0.1787872,0.0893936,0.2681808,0.1787872c0,0.4469662,0,0.983326,0.2681885,1.430294 c0.089386-0.4469681,0.5363541-0.8045406,0.8045349-0.8939342h0.0893936c0,0,0.0893936,0,0.0893936,0.0893936 c0,0.3575726,0.0893936,0.9833279,0.4469681,1.2515068c0-0.2681789,0.1787796-0.5363598,0.3575745-0.715147h2.5030136 c0.1787872,0.1787891,0.3575821,0.4469681,0.3575821,0.715147c0.3575745-0.1787872,0.4469604-0.8045406,0.4469604-1.1621132 c0.0893936-0.0893936,0.1787872-0.0893936,0.1787872-0.0893936l0,0c0.2681808,0.1787872,0.7151489,0.4469662,0.8045425,0.8939342 c0.2681808-0.3575745,0.2681808-0.9833279,0.2681808-1.3409004c0.0893936-0.0893936,0.1787872-0.0893936,0.3575745-0.1787872 l0.2681808,0.3575745c0.1787872-0.1787872,0.2681885-0.3575745,0.2681885-0.5363617 c0.089386-0.0893936,0.2681808-0.0893936,0.3575745-0.1787853c0.1787796,0.1787853,0.4469681,0.4469662,0.4469681,0.6257534 c0.2681808-0.2681808,0.2681808-0.6257534,0.2681808-0.8939342c0.0893936,0,0.0893936-0.0893936,0.1787796-0.0893936h0.0893936 c0.3575745,0.2681808,1.0727158,0.715147,1.162117,1.1621132c0.1787872-0.3575726,0.1787872-0.8045406,0.0893936-1.1621151 h1.9666519L77.0630569,16.0606594L77.0630569,16.0606594z"
        />
        <path
          fill="url(#SVGID_14_)"
          d="M77.1524506,15.9712658l-1.8772659-1.3409004c0,0,1.9666519-3.4863424,1.2515106-3.4863424 c-1.6090851,0.1787863-2.0560455-0.8939342-2.5924072-1.6984739c-0.0893936-0.0893936-0.0893936-0.2681808-0.1787872-0.3575745 c-0.4469604-0.8939333-0.2681808-2.6818008-0.2681808-2.6818008l-1.3408966,1.0727201 C71.0737,6.58496,69.9115829,7.3895006,69.4646149,7.3001075L68.66008,4.6183062l-0.8939362,2.6818013 c-0.4469681,0.0893931-1.6090851-0.8045406-2.5924072,0.1787863L63.922226,6.4061732c0,0,0.2681808,1.6984744-0.1787872,2.503015 c-0.1787872,0.2681799-0.3575745,0.5363598-0.3575745,0.715147c-0.2681808,0.9833269-0.6257553,1.9666548-2.5030136,1.9666548 c-0.5363617,0,1.2515068,3.0393744,1.2515068,3.0393744l-1.8772583,1.3409014h1.8772583 c0,0.3575726-0.0893936,0.8045406,0.0893936,1.1621151c0.0893898-0.4469681,0.7151451-0.8939342,1.1621132-1.1621151h0.268177 c-0.0893898,0.2681808-0.0893898,0.6257534,0.1787872,0.9833279c0-0.1787872,0.268177-0.4469681,0.4469719-0.6257534 c0.0893936,0,0.1787872,0.0893936,0.2681808,0.1787853c0,0.1787872,0.0893936,0.4469681,0.2681808,0.6257553l0.2681885-0.3575745 c0.0893936,0.0893936,0.1787796,0.0893936,0.2681808,0.1787872c0,0.4469662,0,0.983326,0.2681808,1.430294 c0.0893936-0.4469681,0.5363617-0.8045406,0.8045425-0.8939342h0.0893784c0,0,0.0893936,0,0.0893936,0.0893936 c0,0.3575726,0.0893936,0.9833279,0.4469681,1.2515068c0-0.2681789,0.1787796-0.5363598,0.3575745-0.715147h2.5924072 c0.1787872,0.1787872,0.3575745,0.4469681,0.3575745,0.715147c0.3575745-0.1787872,0.4469681-0.8045406,0.4469681-1.1621132 c0.0893936-0.0893936,0.1787872-0.0893936,0.1787872-0.0893936l0,0c0.2681808,0.1787872,0.7151489,0.4469662,0.8045425,0.8939342 c0.089386-0.3575745,0.089386-0.9833279,0.089386-1.3409004c0.0893936-0.0893955,0.1787872-0.0893955,0.3575745-0.1787872 l0.2681885,0.3575726c0.1787796-0.1787853,0.2681808-0.3575726,0.2681808-0.5363598 c0.0893936-0.0893936,0.2681808-0.0893936,0.3575745-0.1787872c0.1787872,0.1787872,0.4469681,0.4469662,0.4469681,0.6257534 c0.2681808-0.2681808,0.2681808-0.6257534,0.2681808-0.8939342c0.0893936,0,0.0893936-0.0893936,0.1787872-0.0893936h0.089386 c0.3575745,0.2681808,1.0727234,0.715147,1.162117,1.1621151c0.1787872-0.3575745,0.1787872-0.8045406,0.0893936-1.1621151 h1.8772507C77.1524506,16.2394466,77.1524506,15.9712658,77.1524506,15.9712658z"
        />
        <linearGradient
          id="SVGID_15_"
          gradientUnits="userSpaceOnUse"
          x1="66.959"
          y1="2576.738"
          x2="66.956"
          y2="2578.612"
          gradientTransform="translate(0 -2560)"
        >
          <stop offset="0.06" stopColor="#fff" />
          <stop offset="0.81" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <path
          fill="url(#SVGID_15_)"
          d="M67.0509949,16.7758064c-0.1787872,0.5363598-0.5363617,0.983326-0.2681808,1.5196877 c0,0.0893936,0.2681808,0.1787872,0.1787796,0c-0.2681808-0.4469681,0.0893936-0.9833279,0.2681808-1.4302959 C67.1403885,16.8652,67.0509949,16.6864128,67.0509949,16.7758064L67.0509949,16.7758064z"
        />
        <linearGradient
          id="SVGID_16_"
          gradientUnits="userSpaceOnUse"
          x1="65.769"
          y1="2576.008"
          x2="65.765"
          y2="2578.061"
          gradientTransform="translate(0 -2560)"
        >
          <stop offset="0.06" stopColor="#fff" />
          <stop offset="0.81" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <path
          fill="url(#SVGID_16_)"
          d="M65.9782791,16.3288383c-0.5363617,0.4469681-0.5363617,1.0727215-0.6257553,1.6090813 c0,0.0893936,0.1787872,0.1787872,0.1787872,0.1787872c0.089386-0.6257534,0.089386-1.2515068,0.6257477-1.6090813 C66.2464523,16.418232,66.0676651,16.2394466,65.9782791,16.3288383L65.9782791,16.3288383z"
        />
        <linearGradient
          id="SVGID_17_"
          gradientUnits="userSpaceOnUse"
          x1="64.695"
          y1="2576.007"
          x2="64.692"
          y2="2577.154"
          gradientTransform="translate(0 -2560)"
        >
          <stop offset="0.06" stopColor="#fff" />
          <stop offset="0.81" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <path
          fill="url(#SVGID_17_)"
          d="M64.6373749,16.0606594c-0.0893936,0.2681789-0.0893936,0.5363598,0,0.8045387 c0,0.0893936,0.1787872,0.1787872,0.1787872,0.0893936c-0.0893936-0.2681789-0.0893936-0.5363598,0-0.8045387 C64.8161621,16.150053,64.6373749,15.9712658,64.6373749,16.0606594L64.6373749,16.0606594z"
        />
        <linearGradient
          id="SVGID_18_"
          gradientUnits="userSpaceOnUse"
          x1="63.834"
          y1="2575.568"
          x2="63.832"
          y2="2576.772"
          gradientTransform="translate(0 -2560)"
        >
          <stop offset="0.06" stopColor="#fff" />
          <stop offset="0.81" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <path
          fill="url(#SVGID_18_)"
          d="M63.922226,15.8818722c-0.2681808,0.2681808-0.3575745,0.4469662-0.3575745,0.8045406 c0,0.0893936,0.1787872,0.1787853,0.1787872,0.1787853c0-0.3575726,0.0893898-0.6257534,0.3575668-0.8045387 C64.1010132,15.9712658,63.922226,15.7924795,63.922226,15.8818722L63.922226,15.8818722z"
        />
        <linearGradient
          id="SVGID_19_"
          gradientUnits="userSpaceOnUse"
          x1="62.551"
          y1="2574.971"
          x2="62.548"
          y2="2576.891"
          gradientTransform="translate(0 -2560)"
        >
          <stop offset="0.06" stopColor="#fff" />
          <stop offset="0.81" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <path
          fill="url(#SVGID_19_)"
          d="M63.0282898,15.2561188c-0.5363579,0.2681799-0.8939323,0.8045406-1.0727196,1.430294 c0,0.0893936,0.1787872,0.1787872,0.1787872,0.1787872c0.0893936-0.6257534,0.4469681-1.1621141,0.983326-1.430295 C63.207077,15.4349051,63.0282898,15.2561188,63.0282898,15.2561188L63.0282898,15.2561188z"
        />
        <linearGradient
          id="SVGID_20_"
          gradientUnits="userSpaceOnUse"
          x1="66.915"
          y1="2576.568"
          x2="66.911"
          y2="2578.51"
          gradientTransform="translate(0 -2560)"
        >
          <stop offset="0.06" stopColor="#fff" />
          <stop offset="0.81" stopColor="#fff" stopOpacity="0" />
        </linearGradient>
        <path
          fill="url(#SVGID_20_)"
          d="M67.0509949,16.8652c-0.3575745,0.4469662-0.4469681,0.983326-0.3575745,1.5196877 c0,0.0893936,0.1787796,0.1787872,0.1787796,0.0893936c-0.1787796-0.5363617,0-1.0727215,0.2681885-1.4302959 C67.2297821,16.9545918,67.0509949,16.7758064,67.0509949,16.8652L67.0509949,16.8652z"
        />
        <g>
          <linearGradient
            id="SVGID_21_"
            gradientUnits="userSpaceOnUse"
            x1="66.885"
            y1="2576.656"
            x2="66.882"
            y2="2578.623"
            gradientTransform="translate(0 -2560)"
          >
            <stop offset="0.06" stopColor="#fff" />
            <stop offset="0.81" stopColor="#fff" stopOpacity="0" />
          </linearGradient>
          <path
            fill="url(#SVGID_21_)"
            d="M66.9616013,16.9545918c-0.3575745,0.4469681-0.4469681,0.9833279-0.1787872,1.5196896 c0,0.0893936,0.1787872,0.1787872,0.1787872,0.0893936c-0.1787872-0.4469681-0.0893936-0.9833279,0.1787872-1.430294 C67.0509949,17.0439854,66.9616013,16.8652,66.9616013,16.9545918L66.9616013,16.9545918z"
          />
        </g>
        <g>
          <linearGradient
            id="SVGID_22_"
            gradientUnits="userSpaceOnUse"
            x1="65.696"
            y1="2576.051"
            x2="65.692"
            y2="2578.152"
            gradientTransform="translate(0 -2560)"
          >
            <stop offset="0.06" stopColor="#fff" />
            <stop offset="0.81" stopColor="#fff" stopOpacity="0" />
          </linearGradient>
          <path
            fill="url(#SVGID_22_)"
            d="M65.8888855,16.3288383c-0.4469681,0.4469681-0.7151489,1.0727215-0.5363617,1.6090813 c0,0.0893936,0.1787872,0.1787872,0.1787872,0.0893936c-0.0893936-0.6257534,0.089386-1.1621132,0.5363541-1.6090813 C66.1570587,16.5076256,65.9782791,16.3288383,65.8888855,16.3288383L65.8888855,16.3288383z"
          />
        </g>
        <g>
          <linearGradient
            id="SVGID_23_"
            gradientUnits="userSpaceOnUse"
            x1="65.71"
            y1="2576.059"
            x2="65.707"
            y2="2577.622"
            gradientTransform="translate(0 -2560)"
          >
            <stop offset="0.06" stopColor="#fff" />
            <stop offset="0.81" stopColor="#fff" stopOpacity="0" />
          </linearGradient>
          <path
            fill="url(#SVGID_23_)"
            d="M65.8888855,16.418232c-0.1787872,0.0893936-0.3575745,0.2681808-0.4469681,0.4469681 c-0.0893936,0.1787853,0,0.4469662,0,0.715147c0,0.0893936,0.1787796,0.1787872,0.1787796,0.0893936 c0-0.2681808-0.089386-0.5363598,0-0.715147c0.0893936-0.1787872,0.2681885-0.2681808,0.3575821-0.3575726 C66.0676651,16.5076256,65.9782791,16.3288383,65.8888855,16.418232L65.8888855,16.418232z"
          />
        </g>
        <g>
          <linearGradient
            id="SVGID_24_"
            gradientUnits="userSpaceOnUse"
            x1="64.733"
            y1="2575.807"
            x2="64.73"
            y2="2577.298"
            gradientTransform="translate(0 -2560)"
          >
            <stop offset="0.06" stopColor="#fff" />
            <stop offset="0.81" stopColor="#fff" stopOpacity="0" />
          </linearGradient>
          <path
            fill="url(#SVGID_24_)"
            d="M64.7267685,16.150053c-0.2681808,0.2681789-0.1787872,0.6257534,0,0.8939323 c0.0893936,0.0893955,0.1787796,0.0893955,0.0893936-0.0893936c-0.1787872-0.1787853-0.0893936-0.4469662,0.089386-0.6257534 C64.9055481,16.2394466,64.7267685,16.0606594,64.7267685,16.150053L64.7267685,16.150053z"
          />
        </g>
        <g>
          <linearGradient
            id="SVGID_25_"
            gradientUnits="userSpaceOnUse"
            x1="64.669"
            y1="2575.713"
            x2="64.666"
            y2="2577.312"
            gradientTransform="translate(0 -2560)"
          >
            <stop offset="0.06" stopColor="#fff" />
            <stop offset="0.81" stopColor="#fff" stopOpacity="0" />
          </linearGradient>
          <path
            fill="url(#SVGID_25_)"
            d="M64.6373749,16.0606594c-0.3575745,0.2681789-0.1787872,0.6257534,0,0.983326 c0,0.0893955,0.2681808,0.1787872,0.1787872,0c-0.1787872-0.2681789-0.2681885-0.6257534,0.089386-0.8045387 C64.9055481,16.2394466,64.7267685,16.0606594,64.6373749,16.0606594L64.6373749,16.0606594z"
          />
          <g>
            <linearGradient
              id="SVGID_26_"
              gradientUnits="userSpaceOnUse"
              x1="63.867"
              y1="2575.379"
              x2="63.865"
              y2="2576.923"
              gradientTransform="translate(0 -2560)"
            >
              <stop offset="0.06" stopColor="#fff" />
              <stop offset="0.81" stopColor="#fff" stopOpacity="0" />
            </linearGradient>
            <path
              fill="url(#SVGID_26_)"
              d="M64.0116196,15.7030859c-0.3575783,0.1787863-0.5363617,0.5363607-0.4469681,0.8939333 c0,0.0893936,0.1787872,0.1787872,0.1787872,0.0893936c-0.0893936-0.3575726,0.0893898-0.715147,0.4469604-0.8939333 C64.1904068,15.8818722,64.1010132,15.7030859,64.0116196,15.7030859L64.0116196,15.7030859z"
            />
            <linearGradient
              id="SVGID_27_"
              gradientUnits="userSpaceOnUse"
              x1="63.83"
              y1="2575.503"
              x2="63.827"
              y2="2577.215"
              gradientTransform="translate(0 -2560)"
            >
              <stop offset="0.06" stopColor="#fff" />
              <stop offset="0.81" stopColor="#fff" stopOpacity="0" />
            </linearGradient>
            <path
              fill="url(#SVGID_27_)"
              d="M63.922226,15.7924795c-0.3575745,0.2681799-0.4469681,0.7151461-0.3575745,1.1621141 c0,0.0893936,0.1787872,0.1787872,0.1787872,0.0893936c-0.1787872-0.4469662,0-0.8045406,0.3575668-1.0727205 C64.1904068,15.9712658,64.0116196,15.7924795,63.922226,15.7924795L63.922226,15.7924795z"
            />
            <linearGradient
              id="SVGID_28_"
              gradientUnits="userSpaceOnUse"
              x1="62.617"
              y1="2574.931"
              x2="62.612"
              y2="2577.466"
              gradientTransform="translate(0 -2560)"
            >
              <stop offset="0.06" stopColor="#fff" />
              <stop offset="0.81" stopColor="#fff" stopOpacity="0" />
            </linearGradient>
            <path
              fill="url(#SVGID_28_)"
              d="M63.0282898,15.3455124c-0.4469643-0.0893936-0.8045387,0.3575735-0.8939323,0.715147 c-0.0893936,0.2681808-0.0893936,0.715147,0.0893936,0.9833279c0.0893898,0.0893936,0.1787872,0.0893936,0.0893898-0.0893936 c-0.0893898-0.0893936,0-0.715147,0-0.8045406c0.0893936-0.2681799,0.4469681-0.715147,0.8045425-0.6257534 C63.207077,15.5242987,63.1176872,15.3455124,63.0282898,15.3455124L63.0282898,15.3455124z"
            />
            <linearGradient
              id="SVGID_29_"
              gradientUnits="userSpaceOnUse"
              x1="62.754"
              y1="2575.135"
              x2="62.75"
              y2="2577.073"
              gradientTransform="translate(0 -2560)"
            >
              <stop offset="0.06" stopColor="#fff" />
              <stop offset="0.81" stopColor="#fff" stopOpacity="0" />
            </linearGradient>
            <path
              fill="url(#SVGID_29_)"
              d="M63.0282898,15.5242987c-0.5363579,0.2681808-0.8045387,0.8045397-0.7151451,1.430295 c0,0.0893936,0.1787872,0.1787872,0.1787872,0.0893936c-0.0893898-0.6257534,0.1787872-1.0727205,0.7151451-1.3409004 C63.207077,15.7030859,63.1176872,15.4349051,63.0282898,15.5242987L63.0282898,15.5242987z"
            />
            <linearGradient
              id="SVGID_30_"
              gradientUnits="userSpaceOnUse"
              x1="62.647"
              y1="2574.865"
              x2="62.643"
              y2="2576.82"
              gradientTransform="translate(0 -2560)"
            >
              <stop offset="0.06" stopColor="#fff" />
              <stop offset="0.81" stopColor="#fff" stopOpacity="0" />
            </linearGradient>
            <path
              fill="url(#SVGID_30_)"
              d="M63.1176872,15.1667252c-0.2681808,0.0893936-0.6257553,0.2681799-0.8045425,0.5363607 c-0.2681808,0.2681799-0.2681808,0.6257524-0.2681808,0.9833269c0,0.0893936,0.1787872,0.1787872,0.1787872,0.1787872 c0-0.3575745,0-0.715147,0.178791-0.9833279c0.1787872-0.2681799,0.5363579-0.3575735,0.8045387-0.4469671 C63.2964745,15.3455124,63.207077,15.1667252,63.1176872,15.1667252L63.1176872,15.1667252z"
            />
            <linearGradient
              id="SVGID_31_"
              gradientUnits="userSpaceOnUse"
              x1="70.371"
              y1="2576.49"
              x2="70.367"
              y2="2578.598"
              gradientTransform="translate(0 -2560)"
            >
              <stop offset="0.06" stopColor="#fff" />
              <stop offset="0.81" stopColor="#fff" stopOpacity="0" />
            </linearGradient>
            <path
              fill="url(#SVGID_31_)"
              d="M70.1797638,16.8652c0.3575745,0.4469662,0.3575745,0.983326,0.0893936,1.430294 c0,0.0893936,0.1787796,0.2681789,0.1787796,0.1787872C70.7161179,17.9379196,70.6267319,17.3121662,70.1797638,16.8652 C70.1797638,16.6864128,70.0903702,16.7758064,70.1797638,16.8652L70.1797638,16.8652z"
            />
            <linearGradient
              id="SVGID_32_"
              gradientUnits="userSpaceOnUse"
              x1="70.384"
              y1="2576.626"
              x2="70.38"
              y2="2578.721"
              gradientTransform="translate(0 -2560)"
            >
              <stop offset="0.06" stopColor="#fff" />
              <stop offset="0.81" stopColor="#fff" stopOpacity="0" />
            </linearGradient>
            <path
              fill="url(#SVGID_32_)"
              d="M70.1797638,16.9545918c0.3575745,0.4469681,0.3575745,0.9833279,0.0893936,1.5196896 c0,0.0893936,0.1787796,0.1787872,0.1787796,0.1787872c0.2681808-0.5363617,0.1787872-1.1621132-0.0893936-1.6090813 C70.2691574,16.8652,70.0903702,16.7758064,70.1797638,16.9545918L70.1797638,16.9545918z"
            />
            <linearGradient
              id="SVGID_33_"
              gradientUnits="userSpaceOnUse"
              x1="71.402"
              y1="2575.949"
              x2="71.398"
              y2="2578.105"
              gradientTransform="translate(0 -2560)"
            >
              <stop offset="0.06" stopColor="#fff" />
              <stop offset="0.81" stopColor="#fff" stopOpacity="0" />
            </linearGradient>
            <path
              fill="url(#SVGID_33_)"
              d="M71.1630859,16.3288383c0.4469681,0.4469681,0.3575745,1.1621151,0.3575745,1.6090813 c0,0.0893936,0.1787872,0.1787872,0.1787872,0.1787872C71.6994553,17.4909534,71.7888489,16.8652,71.1630859,16.3288383 C71.0736923,16.150053,71.0736923,16.2394466,71.1630859,16.3288383L71.1630859,16.3288383z"
            />
            <linearGradient
              id="SVGID_34_"
              gradientUnits="userSpaceOnUse"
              x1="71.584"
              y1="2576.009"
              x2="71.58"
              y2="2578.091"
              gradientTransform="translate(0 -2560)"
            >
              <stop offset="0.06" stopColor="#fff" />
              <stop offset="0.81" stopColor="#fff" stopOpacity="0" />
            </linearGradient>
            <path
              fill="url(#SVGID_34_)"
              d="M71.4312668,16.5970192c0.3575821,0.1787872,0.0893936,1.0727215,0.0893936,1.3409004 c0,0.0893936,0.1787872,0.1787872,0.1787872,0.1787872c0.1787796-0.5363598,0.3575745-1.430294-0.3575745-1.6090813 C71.2524872,16.418232,71.3418808,16.5970192,71.4312668,16.5970192L71.4312668,16.5970192z"
            />
            <linearGradient
              id="SVGID_35_"
              gradientUnits="userSpaceOnUse"
              x1="71.509"
              y1="2576.071"
              x2="71.507"
              y2="2577.387"
              gradientTransform="translate(0 -2560)"
            >
              <stop offset="0.06" stopColor="#fff" />
              <stop offset="0.81" stopColor="#fff" stopOpacity="0" />
            </linearGradient>
            <path
              fill="url(#SVGID_35_)"
              d="M71.2524872,16.418232c0.2681808,0.2681808,0.3575745,0.5363617,0.3575745,0.8939342 c0,0.0893936,0.1787872,0.1787872,0.1787872,0.1787872C71.7888489,17.0439854,71.610054,16.7758064,71.2524872,16.418232 C71.3418808,16.3288383,71.1630859,16.2394466,71.2524872,16.418232L71.2524872,16.418232z"
            />
            <linearGradient
              id="SVGID_36_"
              gradientUnits="userSpaceOnUse"
              x1="72.612"
              y1="2576.068"
              x2="72.61"
              y2="2577.344"
              gradientTransform="translate(0 -2560)"
            >
              <stop offset="0.06" stopColor="#fff" />
              <stop offset="0.81" stopColor="#fff" stopOpacity="0" />
            </linearGradient>
            <path
              fill="url(#SVGID_36_)"
              d="M72.5039902,16.2394466c0.0893936,0.2681789,0,0.5363598-0.0893936,0.715147 c0,0.0893936,0.1787872,0.2681808,0.1787872,0.1787872c0.1787796-0.2681808,0.2681808-0.4469681,0.1787796-0.8045406 C72.5933838,16.2394466,72.4145966,16.150053,72.5039902,16.2394466L72.5039902,16.2394466z"
            />
            <linearGradient
              id="SVGID_37_"
              gradientUnits="userSpaceOnUse"
              x1="73.455"
              y1="2575.454"
              x2="73.453"
              y2="2576.768"
              gradientTransform="translate(0 -2560)"
            >
              <stop offset="0.06" stopColor="#fff" />
              <stop offset="0.81" stopColor="#fff" stopOpacity="0" />
            </linearGradient>
            <path
              fill="url(#SVGID_37_)"
              d="M73.3979187,15.7924795L73.3979187,15.7924795 C73.3085327,15.7924795,73.3085327,15.7924795,73.3979187,15.7924795c0,0.2681799,0,0.5363607,0,0.8045397 c0,0.0893936,0.1787872,0.1787872,0.1787872,0.1787872c0-0.2681808,0-0.4469681-0.0893936-0.715147 c0-0.0893946-0.0893936-0.0893946,0-0.0893946C73.5767136,15.9712658,73.4873199,15.7924795,73.3979187,15.7924795 L73.3979187,15.7924795z"
            />
            <linearGradient
              id="SVGID_38_"
              gradientUnits="userSpaceOnUse"
              x1="74.587"
              y1="2575.01"
              x2="74.583"
              y2="2576.814"
              gradientTransform="translate(0 -2560)"
            >
              <stop offset="0.06" stopColor="#fff" />
              <stop offset="0.81" stopColor="#fff" stopOpacity="0" />
            </linearGradient>
            <path
              fill="url(#SVGID_38_)"
              d="M74.2918549,15.4349051c0.3575745,0.2681808,0.3575745,0.715148,0.4469681,1.1621141 c0,0.0893936,0.1787872,0.1787872,0.1787872,0.0893936c-0.0893936-0.6257534-0.1787872-1.0727205-0.6257553-1.430294 C74.2024612,15.2561188,74.2918549,15.4349051,74.2918549,15.4349051L74.2918549,15.4349051z"
            />
            <linearGradient
              id="SVGID_39_"
              gradientUnits="userSpaceOnUse"
              x1="74.773"
              y1="2575.283"
              x2="74.77"
              y2="2576.515"
              gradientTransform="translate(0 -2560)"
            >
              <stop offset="0.06" stopColor="#fff" />
              <stop offset="0.81" stopColor="#fff" stopOpacity="0" />
            </linearGradient>
            <path
              fill="url(#SVGID_39_)"
              d="M74.5600357,15.5242987c0.1787872,0.2681808,0.2681885,0.5363607,0.2681885,0.8939333 c0,0.0893936,0.1787796,0.1787872,0.1787796,0.1787872c0-0.3575726-0.0893936-0.715147-0.2681808-0.9833269 C74.6494293,15.5242987,74.4706497,15.4349051,74.5600357,15.5242987L74.5600357,15.5242987z"
            />
            <linearGradient
              id="SVGID_40_"
              gradientUnits="userSpaceOnUse"
              x1="74.907"
              y1="2575.48"
              x2="74.905"
              y2="2576.463"
              gradientTransform="translate(0 -2560)"
            >
              <stop offset="0.06" stopColor="#fff" />
              <stop offset="0.81" stopColor="#fff" stopOpacity="0" />
            </linearGradient>
            <path
              fill="url(#SVGID_40_)"
              d="M74.7388229,15.7030859c0.0893936,0.1787863,0.1787872,0.3575735,0.1787872,0.6257524 c0,0.0893936,0.1787796,0.1787872,0.1787796,0.1787872c0-0.2681808-0.0893936-0.4469662-0.1787796-0.715147 C74.8282242,15.7030859,74.6494293,15.6136923,74.7388229,15.7030859L74.7388229,15.7030859z"
            />
            <linearGradient
              id="SVGID_41_"
              gradientUnits="userSpaceOnUse"
              x1="66.749"
              y1="2568.027"
              x2="66.74"
              y2="2573.018"
              gradientTransform="translate(0 -2560)"
            >
              <stop offset="0.06" stopColor="#fff" />
              <stop offset="0.81" stopColor="#fff" stopOpacity="0" />
            </linearGradient>
            <path
              fill="url(#SVGID_41_)"
              d="M66.5146332,8.4622221c0.4469681,0.3575735,0.8045425,0.715147,0.7151489,1.2515068 c-0.0893936,0.3575745-0.2681808,0.715148-0.3575745,1.0727205c-0.2681808,0.715147-0.5363541,1.430295-0.8045425,1.9666548 c0,0.0893936,0.1787872,0.2681799,0.1787872,0.1787863c0.3575745-1.0727205,0.8939362-2.0560484,1.162117-3.128768 C67.497963,9.1773691,66.9616013,8.730402,66.5146332,8.4622221 C66.4252396,8.2834349,66.4252396,8.4622221,66.5146332,8.4622221L66.5146332,8.4622221z"
            />
            <linearGradient
              id="SVGID_42_"
              gradientUnits="userSpaceOnUse"
              x1="70.245"
              y1="2567.806"
              x2="70.238"
              y2="2571.975"
              gradientTransform="translate(0 -2560)"
            >
              <stop offset="0.06" stopColor="#fff" />
              <stop offset="0.81" stopColor="#fff" stopOpacity="0" />
            </linearGradient>
            <path
              fill="url(#SVGID_42_)"
              d="M70.8055191,8.1940413c-0.5363617,0.3575735-1.2515106,0.6257534-1.2515106,1.430294 c0.0893936,0.8045406,0.8045425,1.5196877,0.6257553,2.145442c0,0.0893936,0.1787796,0.1787863,0.1787796,0.1787863 c0.0893936-0.6257534-0.3575745-1.2515068-0.5363541-1.6984739 c-0.1787872-0.4469671-0.1787872-0.8939342,0.1787796-1.2515078 c0.2681885-0.2681799,0.6257553-0.4469671,0.8939362-0.6257534 C70.9843063,8.3728285,70.8949127,8.1046486,70.8055191,8.1940413L70.8055191,8.1940413z"
            />
            <linearGradient
              id="SVGID_43_"
              gradientUnits="userSpaceOnUse"
              x1="67.666"
              y1="2571.456"
              x2="67.664"
              y2="2572.771"
              gradientTransform="translate(0 -2560)"
            >
              <stop offset="0.06" stopColor="#fff" />
              <stop offset="0.81" stopColor="#fff" stopOpacity="0" />
            </linearGradient>
            <path
              fill="url(#SVGID_43_)"
              d="M67.497963,12.2167444c0.089386-0.0893936,0.089386-0.1787872,0.1787796-0.0893936 c0.0893936,0,0.1787872,0.3575726,0.1787872,0.3575726c0,0.0893936,0.1787796,0.1787872,0.1787796,0.0893936 c-0.089386-0.1787863-0.1787796-0.5363607-0.3575745-0.715147c-0.1787796-0.1787863-0.2681808,0-0.3575745,0.1787863 C67.2297821,12.1273508,67.4085693,12.3061371,67.497963,12.2167444L67.497963,12.2167444z"
            />
            <linearGradient
              id="SVGID_44_"
              gradientUnits="userSpaceOnUse"
              x1="69.531"
              y1="2571.527"
              x2="69.528"
              y2="2572.785"
              gradientTransform="translate(0 -2560)"
            >
              <stop offset="0.06" stopColor="#fff" />
              <stop offset="0.81" stopColor="#fff" stopOpacity="0" />
            </linearGradient>
            <path
              fill="url(#SVGID_44_)"
              d="M69.9115829,12.2167444c-0.089386-0.0893936-0.1787796-0.2681808-0.3575745-0.2681808 c-0.2681808-0.0893936-0.3575745,0.2681808-0.4469681,0.5363607c0,0.0893936,0.1787872,0.2681808,0.1787872,0.1787863 C69.3752213,12.574317,69.5540085,11.9485636,69.9115829,12.2167444 C69.9115829,12.3061371,70.0009766,12.3061371,69.9115829,12.2167444L69.9115829,12.2167444z"
            />
            <linearGradient
              id="SVGID_45_"
              gradientUnits="userSpaceOnUse"
              x1="62.123"
              y1="2571.25"
              x2="62.122"
              y2="2572.118"
              gradientTransform="translate(0 -2560)"
            >
              <stop offset="0.06" stopColor="#fff" />
              <stop offset="0.81" stopColor="#fff" stopOpacity="0" />
            </linearGradient>
            <linearGradient
              id="SVGID_46_"
              gradientUnits="userSpaceOnUse"
              x1="61.408"
              y1="2574.852"
              x2="61.406"
              y2="2576.017"
              gradientTransform="translate(0 -2560)"
            >
              <stop offset="0.06" stopColor="#fff" />
              <stop offset="0.81" stopColor="#fff" stopOpacity="0" />
            </linearGradient>
            <linearGradient
              id="SVGID_47_"
              gradientUnits="userSpaceOnUse"
              x1="64.506"
              y1="2568.287"
              x2="64.501"
              y2="2570.904"
              gradientTransform="translate(0 -2560)"
            >
              <stop offset="0.06" stopColor="#fff" />
              <stop offset="0.81" stopColor="#fff" stopOpacity="0" />
            </linearGradient>
            <linearGradient
              id="SVGID_48_"
              gradientUnits="userSpaceOnUse"
              x1="73.305"
              y1="2569.114"
              x2="73.301"
              y2="2571.233"
              gradientTransform="translate(0 -2560)"
            >
              <stop offset="0.06" stopColor="#fff" />
              <stop offset="0.81" stopColor="#fff" stopOpacity="0" />
            </linearGradient>
            <linearGradient
              id="SVGID_49_"
              gradientUnits="userSpaceOnUse"
              x1="64.37"
              y1="2566.552"
              x2="64.368"
              y2="2568.124"
              gradientTransform="translate(0 -2560)"
            >
              <stop offset="0.06" stopColor="#fff" />
              <stop offset="0.81" stopColor="#fff" stopOpacity="0" />
            </linearGradient>
            <linearGradient
              id="SVGID_50_"
              gradientUnits="userSpaceOnUse"
              x1="68.474"
              y1="2564.854"
              x2="68.469"
              y2="2567.564"
              gradientTransform="translate(0 -2560)"
            >
              <stop offset="0.06" stopColor="#fff" />
              <stop offset="0.81" stopColor="#fff" stopOpacity="0" />
            </linearGradient>
            <linearGradient
              id="SVGID_51_"
              gradientUnits="userSpaceOnUse"
              x1="72.505"
              y1="2566.589"
              x2="72.503"
              y2="2568.055"
              gradientTransform="translate(0 -2560)"
            >
              <stop offset="0.06" stopColor="#fff" />
              <stop offset="0.81" stopColor="#fff" stopOpacity="0" />
            </linearGradient>
            <linearGradient
              id="SVGID_52_"
              gradientUnits="userSpaceOnUse"
              x1="75.295"
              y1="2571.12"
              x2="75.294"
              y2="2571.711"
              gradientTransform="translate(0 -2560)"
            >
              <stop offset="0.06" stopColor="#fff" />
              <stop offset="0.81" stopColor="#fff" stopOpacity="0" />
            </linearGradient>
            <linearGradient
              id="SVGID_53_"
              gradientUnits="userSpaceOnUse"
              x1="-3717.401"
              y1="2574.752"
              x2="-3717.403"
              y2="2575.917"
              gradientTransform="matrix(-1 0 0 1 -3641.668 -2560)"
            >
              <stop offset="0.06" stopColor="#fff" />
              <stop offset="0.81" stopColor="#fff" stopOpacity="0" />
            </linearGradient>
            <path
              fill="url(#SVGID_45_)"
              d="M63.0282898,11.5909901L63.0282898,11.5909901 c-0.0893898,0-0.0893898-0.0893936-0.1787872-0.0893936l0,0c0,0-0.0893898-0.1787872-0.1787872-0.1787872 c-0.5363579,0.2681808-1.1621132,0.5363607-1.6984749,0.715147c-0.0893898,0,0.0893936,0.1787872,0.1787872,0.1787872 c0.1787872,0,0.2681808-0.0893936,0.4469681-0.0893936c0,0.0893936,0.0893898,0.1787863,0.1787872,0.1787863h0.0893898 c0,0,0,0,0.0893936,0s0.0893936,0,0.1787872-0.0893936c0.3575745-0.0893936,0.8045425-0.1787863,1.1621132-0.2681808 C63.2964745,11.7697773,63.1176872,11.5909901,63.0282898,11.5909901z"
            />
            <path
              fill="url(#SVGID_46_)"
              d="M62.0449638,15.2561188C62.0449638,15.2561188,62.1343575,15.2561188,62.0449638,15.2561188 c0.0893936-0.0893936,0.0893936-0.1787863,0-0.2681808c0,0,0,0,0.0893936,0c0,0-0.0893936-0.2681799-0.1787872-0.1787863 c-0.3575745,0.1787863-0.7151451,0.4469671-1.0727196,0.6257534v0.0893936 c-0.0893936,0-0.178791,0.0893936-0.2681808,0.0893936c-0.0893936,0,0.0893898,0.1787872,0.1787872,0.1787872 c0.0893936,0,0.1787872-0.0893936,0.2681808-0.0893936c-0.0893936,0-0.1787872,0.0893936-0.1787872,0.0893936 s0.0893898,0.1787863,0.1787872,0.1787863c0.3575745-0.1787863,0.8045387-0.3575735,1.1621132-0.6257534 C62.2237511,15.3455124,62.1343575,15.2561188,62.0449638,15.2561188z"
            />
            <path
              fill="url(#SVGID_47_)"
              d="M65.3525162,8.3728285c-0.8939285,0.6257534-1.4302902,1.5196877-1.8772583,2.4136209 c0,0.0893936,0.1787872,0.2681808,0.1787872,0.1787872c0.5363617-0.8939342,1.0727234-1.7878675,1.8772659-2.4136219 C65.531311,8.4622221,65.3525162,8.2834349,65.3525162,8.3728285z"
            />
            <path
              fill="url(#SVGID_48_)"
              d="M73.934288,11.1440229c-0.2681808-0.3575735-0.3575745-0.8045397-0.5363693-1.1621141 c-0.1787796-0.2681799-0.3575668-0.5363598-0.6257477-0.8045397c-0.0893936-0.0893936-0.1787872-0.1787872-0.0893936,0 c0.2681808,0.3575735,0.5363617,0.715147,0.7151489,1.1621141 C73.4873199,10.6076632,73.6661072,10.875843,73.934288,11.1440229 C73.8448868,11.2334166,74.0236816,11.3228102,73.934288,11.1440229z"
            />
            <path
              fill="url(#SVGID_49_)"
              d="M64.7267685,7.7470746c0,0-0.0893936-0.1787863-0.1787872-0.1787863 c0-0.0893936,0.0893936-0.1787868,0.0893936-0.2681804c0-0.0893941-0.1787872-0.2681804-0.1787872-0.1787868 c-0.089386,0.0893931-0.1787796,0.2681804-0.1787796,0.3575735c0-0.1787863,0-0.3575735,0.0893936-0.5363603 c0-0.0893931-0.1787872-0.1787863-0.1787872-0.1787863c0,0.0893931,0,0.0893931,0,0.1787863 c0-0.0893931,0-0.1787863,0-0.2681799s-0.1787872-0.1787868-0.1787872-0.0893931 c0.0893936,0.357573,0.0893936,0.715147,0.0893936,1.0727205c0,0.0893931-0.0893936,0.2681804-0.0893936,0.357573 c0,0.0893936,0.1787872,0.1787872,0.1787872,0.1787872l0,0c0.0893936,0,0.0893936,0.0893927,0.0893936,0.0893927 c0-0.0893927,0-0.0893927,0-0.1787863l0,0l0,0l0.0893936,0.0893936l0.089386-0.0893936l0,0 C64.6373749,7.8364682,64.7267685,7.7470746,64.7267685,7.7470746z"
            />
            <path
              fill="url(#SVGID_50_)"
              d="M68.66008,7.1213212c-0.0893936,0-0.1787872,0.0893931-0.1787872,0.0893931 c0.1787872-0.1787863,0.3575745-0.2681799,0.5363617-0.4469666c0.089386-0.0893931-0.1787872-0.2681804-0.1787872-0.1787868 c-0.0893936,0.0893931-0.1787872,0.1787868-0.2681808,0.2681799l0.4469681-0.5363603 c0-0.0893931-0.1787872-0.2681799-0.1787872-0.1787868c-0.0893936,0.1787868-0.2681808,0.2681804-0.3575745,0.4469671 C68.5706863,6.4955673,68.66008,6.3167806,68.66008,6.2273874c0.089386-0.1787872,0.1787796-0.357574,0.089386-0.5363607 c0,0,0,0-0.089386-0.0893931c0.089386-0.1787868,0-0.2681799,0.089386-0.5363603 c0-0.0893931-0.089386-0.3575735-0.089386-0.2681799c-0.1787872,0.5363603-0.3575745,1.1621137-0.5363617,1.6984739 c-0.0893936,0.1787868-0.0893936,0.3575735-0.1787872,0.5363603c0,0.0893931-0.089386,0.1787863,0,0.1787863v0.0893936 c0,0.0893931,0.1787872,0.1787863,0.1787872,0.1787863l0,0c0,0.0893936,0.0893936,0.0893936,0.0893936,0.0893936 c0.1787796-0.0893936,0.4469681-0.1787868,0.6257477-0.2681804C68.8388596,7.300108,68.7494659,7.1213212,68.66008,7.1213212z"
            />
            <path
              fill="url(#SVGID_51_)"
              d="M73.0403519,7.0319281c0.0893936-0.0893936,0.1787872-0.1787868,0.2681885-0.2681804 c0.089386,0-0.0893936-0.2681804-0.1787872-0.1787868c-0.4469681,0.4469671-0.9833298,0.8939338-1.4302902,1.3409009 c-0.0893936,0.0893931,0.089386,0.2681804,0.1787796,0.1787868s0.2681808-0.2681804,0.3575745-0.357574l0.0893936,0.0893936 c0,0,0,0,0.0893936,0c0,0,0.0893936,0.1787868,0.1787796,0.1787868c0,0-0.089386-0.1787868-0.1787796-0.1787868 c0.1787796-0.0893936,0.3575668-0.1787868,0.5363541-0.1787868c0,0-0.0893936-0.1787868-0.1787872-0.1787868l0,0 c0.0893936-0.0893931,0.2681808-0.1787863,0.3575745-0.1787863 C73.1297455,7.1213212,73.1297455,7.1213212,73.0403519,7.0319281z"
            />
            <path
              fill="url(#SVGID_52_)"
              d="M76.4373016,11.3228102c-0.0893936,0.0893936,0,0.0893936-0.1787872,0.0893936 c0,0,0,0-0.0893936,0c0,0,0,0-0.0893936,0c-0.089386,0-0.2681808,0-0.3575745,0c-0.3575745,0-0.8045425,0-1.162117-0.2681799 c-0.089386-0.0893936,0,0.0893936,0.0893936,0.1787863c-0.1787796,0-0.2681808-0.0893936-0.4469681-0.0893936 c-0.089386,0,0,0.0893936,0,0.0893936s0,0-0.089386,0l0,0l0,0c0,0.0893936,0.1787796,0.1787863,0.1787796,0.1787863 c0,0.0893946,0.7151489,0.1787872,0.8939362,0.1787872c0.3575745,0,0.7151489,0,1.0727158-0.1787872 C76.4373016,11.5015965,76.347908,11.5015965,76.4373016,11.3228102 C76.5266876,11.4122028,76.4373016,11.2334166,76.4373016,11.3228102z"
            />
            <path
              fill="url(#SVGID_53_)"
              d="M75.0963974,15.1667252C75.0963974,15.1667252,75.0070038,15.1667252,75.0963974,15.1667252 c-0.0893936-0.0893936-0.0893936-0.1787872,0-0.2681808c0,0,0,0-0.0893936,0c0,0,0.0893936-0.2681799,0.1787872-0.1787863 c0.3575745,0.1787863,0.7151489,0.4469671,1.0727158,0.6257534v0.0893936c0.0893936,0,0.1787872,0.0893936,0.2681808,0.0893936 s-0.089386,0.1787872-0.1787796,0.1787872s-0.1787872-0.0893936-0.2681885-0.0893936 c0.0893936,0,0.1787872,0.0893936,0.1787872,0.0893936s-0.0893936,0.1787863-0.1787872,0.1787863 c-0.3575745-0.1787863-0.8045349-0.3575735-1.1621094-0.6257534 C74.9176102,15.2561188,75.0070038,15.1667252,75.0963974,15.1667252z"
            />
          </g>
        </g>
      </g>
      <linearGradient
        id="SVGID_12_"
        gradientUnits="userSpaceOnUse"
        x1="68.537"
        y1="2577.713"
        x2="68.711"
        y2="2570.681"
        gradientTransform="translate(0 -2560)"
      >
        <stop offset="0" stopColor="#fff" />
        <stop offset="0.742" stopColor="#fff" stopOpacity="0" />
      </linearGradient>
    </g>
  )
}

export default DragonSkull
